import { runDigitalReport } from '@/utils/reportUtil';
import spider from './index';
import Locator from '@/utils/locator';

// 后续请直接调用 addTrack 方法
export function addBrowserTrack(spm, subSpm) {
  return addTrack(TRACK_TYPE.CLICK, spm, subSpm);
}

/**
 * 登录埋点
 * @param {String} subSpm 0:进入界面; 1:登录; 2:取消; 3:登录成功; 4:登录失败;
 */
export function addLoginTrack(subSpm) {
  const spm = '1502';
  return addTrack(TRACK_TYPE.LOGIN, spm, subSpm);
}

/** 点击埋点 */
export function addClickTrack(spm, subSpm) {
  return addTrack(TRACK_TYPE.CLICK, spm, subSpm);
}
// 后续请直接调用 addTrack 方法

export function getTraceId() {
  return spider.getTraceId();
}

const tracker = async (type, spm, subSpm, extra) => {
  if(extra && extra.constructor !== Object) {
    return console.error('extra is not Object');
  }
  const { query } = Locator;
  await spider.track(type, {
    contentExtra: Object.assign({
      spm,
      subSpm,
      sceneId: query.sceneId,
      bookGroupId: query.bookGroupId
    }, extra)
  });
};

/**
 * 埋点： `subSpm`新版规则 2023/08/29
 * @param {string} type `TRACK_TYPE.CLICK`
 * @param {*} spm
 * @param {object} subSpm `{click_source: 1}`
 */
export async function addTrack_01(type, spm, subSpm) {
  try {
    let args = [].slice.call(arguments);
    if(args.length === 1 && args[0].constructor === Object) {
      const { type, spm, subSpm, ...extra } = args[0];
      await tracker(type, spm, JSON.stringify(subSpm), extra);
    } else {
      await tracker(type, spm, JSON.stringify(subSpm));
    }
  } catch(e) {
    console.log(e, 'track error');
  }
}

export async function addTrack(type, spm, subSpm) {
  try {
    let args = [].slice.call(arguments);
    if(args.length === 1 && args[0].constructor === Object) {
      const { type, spm, subSpm, ...extra } = args[0];
      await tracker(type, spm, subSpm, extra);
    } else {
      await tracker(type, spm, subSpm);
    }
  } catch(e) {
    console.log(e, 'track error');
  }
}

/**
 * 曝光埋点
 * @param {*} trackParam
 */
export function trackObserver(trackParam, element) {
  // 元素曝光
  if(element && (element instanceof Element) && (document.documentElement.contains(element))) {
    if('IntersectionObserver' in window) {
      // 选择需要监测的元素
      const elementsToTrack = element;

      //创建IntersectionObserver实例
      const observerElement = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            // 元素进入可视区域，触发曝光埋点
            // console.log('Element exposed:', entry.target);
            // 发送曝光埋点数据
            runDigitalReport(trackParam, addTrack_01);
            // 如果只需要触发一次曝光埋点，可以取消观察
            observer.unobserve(entry.target);
          }
        });

        observerElement.observe(elementsToTrack);
      }, {
        root: null,  // 使用默认的视口作为根
        rootMargin: '0px',
        threshold: 0.1 // 元素至少有10%进入可视区域时触发
      });
    }
  } else {
    let timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      // console.log('No DOM changes detected for 3 seconds');
      runDigitalReport(trackParam, addTrack_01);
    }, 500);
  }

}

export const TRACK_TYPE = {
  'BROWSE': 'BROWSE',
  'CLICK': 'CLICK',
  'SCAN': 'SCAN',
  'SEARCH': 'SEARCH',
  'ORDER': 'ORDER',
  'PAY_OK': 'PAY_OK', // 前端不使用此类型
  'SHARE': 'SHARE',
  'SHARE_OPEN': 'SHARE_OPEN',
  'LOGIN': 'LOGIN',
  'KEEP_BEAT': 'KEEP_BEAT',
  'ENTER': 'ENTER'
};

